import React from 'react';
import {Switch, Route, Redirect} from 'react-router-dom';
import ErrorsPage from './Pages/Errors/Components/ErrorsPage';
import WaterSystemPage from "./Pages/WaterSystems/WaterSystemsPage";
import SignedOutPage from './Pages/SignedOut/SignedOutPage';
import ReportsPage from "./Pages/ReportsPage/ReportsPage";
import {apolloClientReports} from "./GraphQL/config";
import {ApolloProvider} from "@apollo/client";
import UsersPage from "./Pages/Users/UsersPage";
import MonitoringHistoryPage from "./Pages/Monitoring/MonitoringHistoryPage";
import MonitoringPage from "./Pages/Monitoring/MonitoringPage";
import ControlUnitsPage from "./Pages/ControlUnits/ControlUnitsPage";
import ControlUnitsDetailsPage from "./Pages/ControlUnits/ControlUnitsDetailsPage";
import HardwareCatalogPage from "./Pages/HardwareCatalog/Components/HardwareCatalogPage";

export default function Routes() {
    return (
        <Switch>
            <Route exact path='/'>
                <Redirect to='/waterSystems'/>
            </Route>
            <Route exact path='/monitoring' component={MonitoringPage}/>
            <Route exact path='/monitoringHistory' component={MonitoringHistoryPage}/>
            <Route exact path='/errors' component={ErrorsPage}/>
            <Route exact path='/waterSystems' component={WaterSystemPage}/>
            <Route exact path='/controlUnits' component={ControlUnitsPage}/>
            <Route exact path='/hardwareCatalog' component={HardwareCatalogPage}/>
            <Route exact path='/controlUnits/:controlUnitId' component={ControlUnitsDetailsPage}/>
            <Route exact path='/users' component={UsersPage}/>
            <Route exact path='/signed-out' component={SignedOutPage}/>
            <ApolloProvider client={apolloClientReports}>
                <Route exact path='/reports' component={ReportsPage}/>
            </ApolloProvider>
        </Switch>
    )
}
